import * as LinkHelper from "@/utils/LinkHelper";
import { MessageBox } from "element-ui";

function goTo(router, options) {
  if (!router) {
    return;
  }
  if (typeof router === "function") {
    return router(options);
  }
  if (router && typeof router.push === "function") {
    router.push(options);
  }
}

function obtainMessage(err) {
  if (err instanceof Error) {
    return `<pre>${err.message}\n${err.stack}</pre>`;
  }
  return JSON.stringify(err);
}

export default function (router) {
  return function (err) {
    if (err && err.status) {
      const { status, data } = err;
      if (status === 401) {
        window.location.href = LinkHelper.obtainLoginUrl();
        return;
      }
      if (status === 500) {
        goTo(router, { name: "error" });
        return;
      }
      if (status === 502) {
        goTo(router, { name: "maintaining" });
        return;
      }
      // 兼容 cas 的返回值
      if (status === 200 && data && `${data.code}` === "20003") {
        window.location.href = LinkHelper.obtainLoginUrl();
        return;
      }
    }
    console.error(err);

    if (process.env.VUE_APP_ENV === "development") {
      const title = "异常信息(只在非生产环境显示)";
      const message = obtainMessage(err);
      MessageBox.alert(message, title, {
        // center: true,
        dangerouslyUseHTMLString: true,
        customClass: "error-dialog",
      });
    }
  };
}
